import type { IconData } from '@stacksjs/iconify-core'

export const schoolScienceBag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 18.28H32v9.14h-1.53Z\"/><path fill=\"currentColor\" d=\"M27.42 18.28h3.05v-1.52h-3.05v-6.1H25.9v19.81h1.52v-1.52h3.05v-1.53h-3.05zM24.38 7.61h1.52v3.05h-1.52ZM6.09 30.47H25.9V32H6.09Zm16.76-10.66h1.53v7.61h-1.53ZM21.33 6.09h3.05v1.52h-3.05ZM9.14 27.42h13.71v1.53H9.14Zm1.52-6.09v1.52h1.53v3.05h1.52v-3.05h7.62v-1.52zM13.71 0h4.57v1.52h-4.57Zm0 13.71h1.52v1.52h1.53v-1.52h1.52v-1.52h1.52v-1.53h-1.52V9.14h-1.52v1.52h-1.53V9.14h-1.52v1.52h-1.52v1.53h1.52zm7.62-7.62V4.57H19.8V1.52h-1.52v3.05h-4.57V1.52h-1.52v3.05h-1.53v1.52zM9.14 18.28h13.71v1.53H9.14ZM7.61 6.09h3.05v1.52H7.61Zm0 13.72h1.53v7.61H7.61ZM6.09 7.61h1.52v3.05H6.09Zm0 3.05H4.57v6.1H1.52v1.52h3.05v9.14H1.52v1.53h3.05v1.52h1.52zM0 18.28h1.52v9.14H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default schoolScienceBag
